/**
 * 状态序列化工具
 * 用于 SSR 状态在服务端和客户端之间的传递
 */

/**
 * 序列化状态为 JSON 字符串（带 XSS 防护）
 *
 * 【XSS 防护说明】
 * 转义 < > 和特殊 Unicode 字符，防止脚本注入攻击
 *
 * @param {object} state - 要序列化的状态对象
 * @returns {string} 序列化后的字符串
 */
export function serialize(state) {
  if (!state) return '';

  try {
    const json = JSON.stringify(state);
    // XSS 防护：转义危险字符
    return json
      .replace(/</g, '\\u003C')      // 防止 </script> 注入
      .replace(/>/g, '\\u003E')
      .replace(/\u2028/g, '\\u2028') // 行分隔符
      .replace(/\u2029/g, '\\u2029'); // 段落分隔符
  } catch (error) {
    console.error('[serialize] 序列化失败:', error);
    return '';
  }
}

/**
 * 反序列化 JSON 字符串为对象
 *
 * @param {string} stateString - JSON 字符串
 * @returns {object|null} 解析后的对象
 */
export function deserialize(stateString) {
  if (!stateString) return null;

  try {
    return JSON.parse(stateString);
  } catch (error) {
    console.error('[deserialize] 反序列化失败:', error);
    return null;
  }
}

/**
 * 从 window.__INITIAL_STATE__ 获取初始状态
 *
 * 【工作原理】
 * 服务端将状态序列化后嵌入 HTML：
 * <script>window.__INITIAL_STATE__='{"data":{...}}'</script>
 *
 * @returns {object|null} 初始状态对象
 */
export function getInitialState() {
  // 环境检测：服务端没有 window 对象
  if (typeof window === 'undefined') {
    return null;
  }

  return window.__INITIAL_STATE__ || null;
}

export default {
  serialize,
  deserialize,
  getInitialState,
};
